<template>
    <div class="gameRendering">
        <div class="gameRendering__left">
            <main-menu></main-menu>
        </div>
        <div class="gameRendering__right">
            <div>
                <div class="title-container">
                    <h3 class="grm-title">1. Choose a project</h3>
                    <h3 class="grm-title">2. Choose environment</h3>
                </div>
                <select class="form__select" v-model="chosenProject">
                    <option :key="proj.value" :value="proj.value" v-for="proj in projects">
                        {{ proj.name }}
                    </option>
                </select>
                <select class="form__select" v-model="chosenEnv">
                    <option :key="env.value" :value="env.value" v-for="env in envs">
                        {{ env.name }}
                    </option>
                </select>
                <PickGamesList :pickedGames="grmGames" :allGames="allGames" :onSave="onSave" />
            </div>

            <InfoModal
                v-if="isGrmListEdited"
                :msg="'Game Rendering list was successfully edited.'"
                :onCloseModal="closeInfoModal"
            ></InfoModal>
        </div>
    </div>
</template>

<script>
import MainMenu from '../MainMenu/MainMenu.vue';
import { projects } from '../../constants/projects';
import { aarpEnvironments, arenaEnvironments, arkcomEnvironments } from '../../constants/environmentNames';
import config from '../../config';

import { ClearCacheService } from '../../services/ClearCacheService';
import InfoModal from '../InfoModal/InfoModal.vue';
import CloseIcon from '../CloseIcon/CloseIcon.vue';
import AddIcon from '../AddIcon/AddIcon.vue';
import PickGamesList from '../PickGamesList/PickGamesList.vue';
export default {
    name: 'GameRendering',
    components: { MainMenu, CloseIcon, AddIcon, InfoModal, PickGamesList },
    data() {
        return {
            chosenProject: null,
            chosenEnv: null,
            envs: null,
            projects,
            arenaEnvironments,
            arkcomEnvironments,
            aarpEnvironments,
            allGames: [],
            grmGames: [],
            isGrmListEdited: false,
            editGrmListError: null,
        };
    },
    methods: {
        getAllGames: function () {
            return this.$gameApi.get(`/games`).then(games => games.map(game => game.slug));
        },
        getGRMGames: function () {
            return this.$http
                .get(`${config.apiUrl}/game-rendering?project=${this.chosenProject}&env=${this.chosenEnv}`)
                .then(
                    (response) => response.body,
                    (error) => {
                        console.error(error);
                    }
                );
        },
        onSave: function (gamesToSave) {
            return this.$http
                .post(
                    `${config.apiUrl}/game-rendering?project=${this.chosenProject}&env=${this.chosenEnv}`,
                    gamesToSave
                )
                .then(
                    () => {
                        this.isGrmListEdited = true;
                        this.clearCache();
                    },
                    (error) => {
                        this.editGrmListError = error.body.Message ?? 'failed to save game rendering list';
                        console.error(error);
                    }
                );
        },
        closeInfoModal: function () {
            this.isGrmListEdited = false;
        },
        clearCache: function () {
            const fileUrl = `https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/${this.chosenProject}/${this.chosenEnv}/index.json`;
            ClearCacheService.clearCacheByItems([fileUrl], 'Url', 'Delete')
                .then((res) => {
                    if (res.ok) {
                        console.debug('cache cleared successfully');
                        return;
                    }
                    console.error('cache clear error', res);
                })
                .catch((err) => console.error('cache clear request error', err));
        },
    },
    watch: {
        chosenProject: {
            handler(newValue) {
                switch (newValue) {
                    case 'arkcom':
                        this.envs = arkcomEnvironments;
                        break;
                    case 'arena51':
                        this.envs = arenaEnvironments;
                        break;
                    case 'aarp':
                        this.envs = aarpEnvironments;
                        break;
                    default:
                        break;
                }
                this.chosenEnv = null;
            },
        },
        chosenEnv: {
            handler(newValue) {
                if (!newValue) {
                    return;
                }
                const requests = !this.allGames.length ? [this.getGRMGames, this.getAllGames] : [this.getGRMGames];
                // this.isGamesLoadInProgress = true;
                Promise.all(requests.map((r) => r())).then(([grmGames, allGames]) => {
                    if (allGames) {
                        this.allGames = allGames;
                    }
                    this.grmGames = grmGames;
                    this.grmSearch = null;
                    this.allGamesSearch = null;
                    // this.isGamesLoadInProgress = false;
                });
            },
        },
        grmGames: {
            handler(newGrmGames) {
                this.filteredGrmGames = newGrmGames;
                this.filteredAllGames = this.allGames.filter((g) => !newGrmGames.includes(g));
            },
        },
        grmSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedGrmGames = this.filteredGrmGames;
                }
                this.searchedGrmGames = this.filteredGrmGames.filter((g) => g.includes(newValue));
            },
        },
        allGamesSearch: {
            handler(newValue) {
                if (!newValue) {
                    this.searchedAllGames = this.filteredAllGames;
                }
                this.searchedAllGames = this.filteredAllGames.filter((g) => g.includes(newValue));
            },
        },
    },
};
</script>

<style scoped src="./gameRendering.scss" lang="scss"></style>
